import { createAsyncThunk, createSlice, Action } from "@reduxjs/toolkit";

import { ICustomCssModelv1 } from "api/files";
import { adminFilesApi, filesApi } from "api/instances";

export enum GLOBAL_LAYOUT_STATUS {
    FETCHING,
    IDLE,
    SUCCEEDED,
    FAILED
}

export interface IGlobalLayoutState {
    customCss?: ICustomCssModelv1;
    status: GLOBAL_LAYOUT_STATUS;
}

interface IFetchCustomCssPayload {
    admin: boolean;
    tenantId: string;
}

interface ISetSasUrlAction extends Action {
    payload: string;
}

const DEFAULT_STATE: IGlobalLayoutState = {
    status: GLOBAL_LAYOUT_STATUS.IDLE
};

export const fetchCustomCssFileAsync = createAsyncThunk("FETCH_CUSTOM_CSS", async ({ admin, tenantId }: IFetchCustomCssPayload, thunkApi) => {
    try {
        const res = admin
            ? await adminFilesApi.getCustomTinyMceCss()
            : await filesApi.getCustomTinyMceCss(tenantId);

        thunkApi.dispatch({ type: globalLayoutSlice.actions.SET_SAS_URL, payload: res.sasUrl });
    } catch (err) {
        throw err;
    }
});

export const globalLayoutSlice = createSlice({
    name: "customCss",
    initialState: DEFAULT_STATE,
    reducers: {
        SET_SAS_URL: (state: IGlobalLayoutState, action: ISetSasUrlAction) => {
            if (state.customCss)
                state.customCss.sasUrl = action.payload;
            else
                state.customCss = { sasUrl: action.payload };
        }
    },
    extraReducers: (builder) => builder
        .addCase(fetchCustomCssFileAsync.pending, (state: IGlobalLayoutState) => {
            state.status = GLOBAL_LAYOUT_STATUS.FETCHING
        })
        .addCase(fetchCustomCssFileAsync.fulfilled, (state: IGlobalLayoutState) => {
            state.status = GLOBAL_LAYOUT_STATUS.SUCCEEDED;
        })
        .addCase(fetchCustomCssFileAsync.rejected, (state: IGlobalLayoutState) => {
            state.status = GLOBAL_LAYOUT_STATUS.FAILED;
        })
});
